import gql from "graphql-tag";

// Import the fragments we need for blocks
// Note: We're importing from entryFragmentsForExport.js since it has all the fields we need
import { entryFragmentsForFetchAllEntriesQuery } from "./entryFragmentsForFetchAllEntriesQuery";

// Query to fetch individual entries by ID without pulling nested relationships
const QUERY_MISSING_ENTRIES = gql`
  query FetchMissingEntries($ids: [QueryArgument], $siteId: [QueryArgument]) {
    globalVariables: entries(
      section: "variables"
      siteId: $siteId
      type: ["variable"]
    ) {
      id # need id only for global variables as they may be overridden by product scoped variables, nested variables are not implemented yet
      ...VariableEntryFields
    }
    dateUpdatedPrimarySiteEntries: entries(
      id: $ids
      status: ["enabled", "disabled"]
      siteId: ["1"]
    ) {
      id
      siteId
      ... on product_Entry {
        contentDateUpdated
      }
      ... on chapter_Entry {
        contentDateUpdated
      }
      ... on articleLongform_Entry {
        contentDateUpdated
      }
      ... on articleWithSteps_Entry {
        contentDateUpdated
      }
      ... on articleLongformComposableEntries_Entry {
        contentDateUpdated
      }
      ... on articleStepByStepComposableEntries_Entry {
        contentDateUpdated
      }

      ... on textBlock_Entry {
        contentDateUpdated
      }

      ... on textPlusImageBlock_Entry {
        contentDateUpdated
      }

      ... on largeImageBlock_Entry {
        contentDateUpdated
      }

      ... on calloutBlock_Entry {
        contentDateUpdated
      }

      ... on videoBlock_Entry {
        contentDateUpdated
      }

      ... on fullWidthImageBlock_Entry {
        contentDateUpdated
      }
      ... on richTextInlineImagesBlock_Entry {
        contentDateUpdated
      }
      ... on columnComposableBlock_Entry {
        contentDateUpdated
      }
    }

    entries(id: $ids, siteId: $siteId, status: ["enabled", "disabled"]) {
      id
      siteId
      siteHandle
      language
      typeHandle
      sectionHandle
      title

      # Manual/Product entries - just core fields, no children
      ... on product_Entry {
        id
        userTitle
        translationImportTimestamp
        pageLayoutType
        productIcon {
          uid
          url
        }
        productCategory {
          id
          title
        }
        productFeatures {
          id
          title
        }
      }

      # Chapter entries - just core fields, no topicArticles
      ... on chapter_Entry {
        id
        userTitle
        translationImportTimestamp
      }

      # Article entries - just core fields, no content blocks
      ... on articleLongform_Entry {
        id
        userTitle
        translationImportTimestamp
        subtopicGroupTag {
          title
        }
        showForTheFollowingProducts {
          id
          title
        }
        showForTheFollowingProductCategories {
          id
          title
        }
        showForTheFollowingProductFeatures {
          id
          title
        }
        showForThisSiteLanguage
      }

      ... on articleWithSteps_Entry {
        id
        userTitle
        translationImportTimestamp
        subtopicGroupTag {
          title
        }
        showForTheFollowingProducts {
          id
          title
        }
        showForTheFollowingProductCategories {
          id
          title
        }
        showForTheFollowingProductFeatures {
          id
          title
        }
        showForThisSiteLanguage
      }

      ... on articleLongformComposableEntries_Entry {
        id
        userTitle
        translationImportTimestamp
        subtopicGroupTag {
          title
        }
        showForTheFollowingProducts {
          id
          title
        }
        showForTheFollowingProductCategories {
          id
          title
        }
        showForTheFollowingProductFeatures {
          id
          title
        }
        showForThisSiteLanguage
      }

      ... on articleStepByStepComposableEntries_Entry {
        id
        userTitle
        translationImportTimestamp
        subtopicGroupTag {
          title
        }
        showForTheFollowingProducts {
          id
          title
          typeHandle
        }
        showForTheFollowingProductCategories {
          id
          title
        }
        showForTheFollowingProductFeatures {
          id
          title
        }
        showForThisSiteLanguage
      }

      # Content blocks - use the full fragments since they don't have nested relationships
      ... on textBlock_Entry {
        ...TextBlockFields
      }

      ... on textPlusImageBlock_Entry {
        ...TextPlusImageBlockFields
      }

      ... on largeImageBlock_Entry {
        ...LargeImageBlockFields
      }

      ... on calloutBlock_Entry {
        ...CalloutBlockFields
      }

      ... on videoBlock_Entry {
        ...VideoBlockFields
      }

      ... on fullWidthImageBlock_Entry {
        ...FullWidthImageBlockFields
      }
      ... on richTextInlineImagesBlock_Entry {
        ...RichTextInlineImagesBlockFields
      }
      ... on columnComposableBlock_Entry {
        ...ColumnComposableBlockFields
      }

      # Step entries (special case - they're part of matrix but we might query them separately)
      ... on topicArticleStepBuilderBlock_Entry {
        id
        sortOrder
        typeHandle
        showForTheFollowingProducts {
          id
          title
        }
        showForTheFollowingProductCategories {
          id
          title
        }
        showForTheFollowingProductFeatures {
          id
          title
        }
        showForThisSiteLanguage
      }
    }
  }

  # Include the fragments for block types
  ${entryFragmentsForFetchAllEntriesQuery}
`;

export default QUERY_MISSING_ENTRIES;
